<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i> Export</b-button
          >
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Trx.</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >until</span
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-button class="btn btn-success ml-3" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply
            </b-button>
            <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="tblData.items"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        @row-dblclicked="rowDblClicked"
        :busy="isBusy"
        show-empty
      >
        <template #thead-top="data">
          <b-tr>
            <b-th colspan="2"></b-th>
            <b-th colspan="3" variant="primary" class="text-center"
              ><strong>REPAYMENT</strong></b-th
            >
            <b-th colspan="3" variant="success" class="text-center"
              ><strong>BANK-IN</strong></b-th
            >
            <b-th colspan="3" variant="warning" class="text-center"
              ><strong>AKUMULASI OS</strong></b-th
            >
          </b-tr>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.begining }}
          <span v-if="data.item.begining != true">
            {{ (tblData.page - 1) * tblData.limit + data.index }}
          </span>
        </template>
        <template v-slot:cell(transaction_date)="data">
          <span v-if="data.item.begining">
            <strong>{{ data.item.transaction_date }}</strong></span
          >
          <span v-else>
            {{ data.item.transaction_date | moment("YYYY MMM DD") }}</span
          ></template
        >
        <template v-slot:cell(count_trx)="data">
          <span v-if="data.item.begining">
            <strong>{{ data.item.count_trx | numFormat("0,0") }}</strong></span
          >
          <span v-else>{{ data.item.count_trx | numFormat("0,0") }}</span>
        </template>
        <template v-slot:cell(principal_sum)="data">
          <span v-if="data.item.begining">
            <strong>{{
              data.item.principal_sum | numFormat("0,0.00")
            }}</strong></span
          >
          <span v-else>{{
            data.item.principal_sum | numFormat("0,0.00")
          }}</span>
        </template>
        <template v-slot:cell(interest_after_tax_sum)="data">
          <span v-if="data.item.begining">
            <strong>{{
              data.item.interest_after_tax_sum | numFormat("0,0.00")
            }}</strong></span
          >
          <span v-else>{{
            data.item.interest_after_tax_sum | numFormat("0,0.00")
          }}</span>
        </template>
        
        <template v-slot:cell(repayment_principal_sum)="data">
          <span v-if="data.item.begining">
            <strong>{{
              data.item.repayment_principal_sum | numFormat("0,0.00")
            }}</strong></span
          >
          <span v-else>{{
            data.item.repayment_principal_sum | numFormat("0,0.00")
          }}</span>
        </template>
        <template v-slot:cell(repayment_interest_sum)="data">
          <span v-if="data.item.begining">
            <strong>{{
              data.item.repayment_interest_sum | numFormat("0,0.00")
            }}</strong></span
          >
          <span v-else>{{
            data.item.repayment_interest_sum | numFormat("0,0.00")
          }}</span>
        </template>
        <template v-slot:cell(total_repayment_bank)="data">
          <span v-if="data.item.begining">
            <strong>{{
              data.item.total_repayment_bank | numFormat("0,0.00")
            }}</strong></span
          >
          <span v-else>{{
            data.item.total_repayment_bank | numFormat("0,0.00")
          }}</span>
        </template>
        <template v-slot:cell(principal_os_amt)="data">
          <span v-if="data.item.begining">
            <strong>{{
              data.item.principal_os_amt | numFormat("0,0.00")
            }}</strong></span
          >
          <span v-else>{{
            data.item.principal_os_amt | numFormat("0,0.00")
          }}</span>
        </template>
        <template v-slot:cell(interest_os_amt)="data">
          <span v-if="data.item.begining">
            <strong>{{
              data.item.interest_os_amt | numFormat("0,0.00")
            }}</strong></span
          >
          <span v-else>{{
            data.item.interest_os_amt | numFormat("0,0.00")
          }}</span>
        </template>
        <template v-slot:cell(os_amt)="data">
          <span v-if="data.item.begining">
            <strong>{{ data.item.os_amt | numFormat("0,0.00") }}</strong></span
          >
          <span v-else>{{ data.item.os_amt | numFormat("0,0.00") }}</span>
        </template>
        <template v-slot:custom-foot>
          <b-tr>
            <b-th colspan="2" class="text-center"
              ><span class="">TOTAL</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.count_trx | numFormat("0,0")
              }}</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.principal | numFormat("0,0.00")
              }}</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.interest_repaid_aftertax | numFormat("0,0.00")
              }}</span></b-th>
            <b-th colspan="6"></b-th>
          </b-tr>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import repayment from "../../apis/repayment";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isLoading: false,
      isBusy: false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "repayment_date",
        sortDesc: false,
        tgl1: moment().startOf("M").format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
        partnerTransactionId: "",
        loan_id: "",
        total_repayment: 0,
        principal: 0,
        interest_repaid: 0,
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "transaction_date",
          label: "Transaction Date",
          thClass: "text-center",
          thStyle: "min-width:70px",
          sortable: true,
        },
        {
          key: "count_trx",
          label: "Count Trx.",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "principal_sum",
          label: "Principal/Refund",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "interest_after_tax_sum",
          label: "COF After Tax",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "repayment_principal_sum",
          label: "Principal",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "repayment_interest_sum",
          label: "COF After Tax",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "total_repayment_bank",
          label: "TOTAL",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "principal_os_amt",
          label: "OS Principal",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "interest_os_amt",
          label: "OS Interest",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "os_amt",
          label: "TOTAL OS",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      return fields;
    },
  },
  created() {
    this.data();
  },
  methods: {
    rowDblClicked(record, index) {
      const route = this.$router.resolve({
        name: "transaction.repayment",
        query: {
          tgl1: moment(record.repayment_date).format("YYYY-MM-DD"),
          tgl2: moment(record.repayment_date).format("YYYY-MM-DD"),
        },
      });
      window.open(route.href, "_blank");
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || "") == "") {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
        }

        const list = await repayment.reportrepaymentvsrealisasi(this.tblData);
        this.isBusy = false;
        this.tblData.items = list;
        this.tblData.total= list.length;
        // return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await repayment.exportreportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
        this.data();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tableKey",
        sortDesc: false,
        tablename: "repaymentupload",
        customQuery: "",
        tgl1: "",
        tgl2: "",
        partnerTransactionId: "",
        loan_id: "",
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>